import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  MdOutlinePrecisionManufacturing,
  MdOutlineVerified,
  MdArrowForwardIos,
} from "react-icons/md";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { VscTools } from "react-icons/vsc";
import { RiShoppingBagLine } from "react-icons/ri";
import { GiDrill } from "react-icons/gi";
import { HiMail } from "react-icons/hi";
import { BsTelephoneInbound, BsWhatsapp } from "react-icons/bs";
import { SiGooglemaps } from "react-icons/si";

function Nosotros() {
  const [offset, setOffset] = useState(0);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  function hashLinkScroll(hash) {
    if (hash !== "") {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) element.scrollIntoView();
      }, 0);
    }
  }

  const onScroll = () => setOffset(window.pageYOffset);
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.removeEventListener("resize", handleResize);
    window.addEventListener("resize", handleResize);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="back__main">
      <header>
        <div className="hero__espacio_nosotros" id="nosotros"></div>

        <nav className="lista">
          <ul className="lista__opciones">
            <li className="lista__opcion">
              {/* <div onClick={() => hashLinkScroll('hero__nosotros')} className="lista__link" >Inicio</div> */}
              <Link to="/">
                <div className="lista__link">Inicio</div>
              </Link>
            </li>
            {/* <li className="lista__opcion" >
                            <div onClick={() => hashLinkScroll('servicios__lista')} className="lista__link" >Nuestros Servicios</div>
                        </li> */}
            <li className="lista__opcion">
              <div
                href=""
                className="lista__link"
                onClick={() => hashLinkScroll("nosotros")}
              >
                Nosotros
              </div>
            </li>
            {/* <li className="lista__opcion" >
                            <div href="" className="lista__link" >Galería</div>
                        </li> */}
            <li className="lista__opcion">
              <div
                onClick={() => hashLinkScroll("footer")}
                className="lista__link"
              >
                Contacto
              </div>
            </li>
            <li className="lista__opcion">
              <div
                onClick={() => hashLinkScroll("footer")}
                className="lista__link"
              >
                Horario
              </div>
            </li>
            <li className="lista__opcion">
              <Link to="/login">
                <div className="lista__link">Sistema IDN</div>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="hero__nosotros"></div>
        <h2 className="nosotros__main">Sobre Nosotros</h2>
      </header>

      <section className="visionM">
        <h2 className="visionM__titulo">Nuestra Misión</h2>

        <p className="visionM__texto">
          En Impacto del Norte, estamos dedicados/as a ofrecer soluciones integrales a través de la 
          comercialización, arriendo, reparación y mantención de equipos para la industria minera, 
          energética y de transporte. Nos comprometemos a satisfacer las necesidades de nuestros clientes 
          con profesionalismo, excelencia, cumpliendo plazos de entrega y manteniendo precios 
          competitivos. Nuestra gestión está respaldada por nuestras certificaciones ISO 9.001-2015, 14.001-
          2015 y 45.001-2018, garantizando estándares óptimos en calidad, sostenibilidad y seguridad.
        </p>

        <img
          src="/img/Inicio/banderas.webp"
          alt="ejemplo"
          className="misionM__img"
        />
      </section>

      <section className="misionM">
        <h2 className="misionM__titulo">Nuestra Visión</h2>

        <p className="misionM__texto">
        Consolidarnos como un referente de calidad, compromiso y excelencia en la industria, 
        expandiendo nuestro alcance hacia más empresas, plantas y faenas, y participando en proyectos 
        de creciente impacto. A través de nuestra certificación ISO 9.001-2015, 14.001-2015 y 45.001-
        2018, reafirmamos nuestra capacidad para cumplir con los requisitos regionales, nacionales e 
        internacionales, asegurando un crecimiento sostenible y una operación segura en los sectores 
        minero, energético y de transporte.
        </p>

        <img src="/img/LogoIDN.webp" alt="Logo IDN" className="visionM__img" />
      </section>

      <section className="valores">
        <h2 className="valores__titulo">Nuestros Valores</h2>

        <ul className="valores__texto valores__ul">
          <li>Responsabilidad: Cumplimos con nuestros compromisos de manera ética y profesional.</li>
          <li>Honestidad: Actuamos con transparencia en cada proceso.</li>
          <li>Compromiso: Nos enfocamos en la satisfacción y confianza de nuestros clientes.</li>
          <li>Excelencia: Buscamos la mejora continua en cada servicio.</li>
          <li>Calidad: Respaldada por un Sistema de Gestión Integrado (certificación ISO).</li>
          <li>Trabajo en equipo: Valoramos la colaboración para lograr soluciones eficientes.</li>
          <li>Lealtad: Construimos relaciones de confianza y respeto con nuestros socios y clientes.</li>
        </ul>

        <div className="valores__bloque">
          <img
            src="/img/Inicio/pintando.webp"
            alt="ejemplo"
            className="valores__img"
          />

        </div>
      </section>

      <section className="equipo">
        <h2 className="nosotros__main">Nuestro Equipo</h2>

        <div className="equipo__flex">
          <div className="equipo__persona">
            <div className="equipo1__img">
              <div className="equipo__info">
                <h3 className="equipo__experiencia">22 Años de Experiencia</h3>
                <h3 className="equipo__especializacion">
                  Especialización en Hidráulica Y Neumática
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Alberto García López</h2>
              <h3 className="equipo__cargo">Fundador y Gerente técnico</h3>
            </div>
          </div>

          <div className="equipo__persona">
            <div className="equipo2__img">
              <div className="equipo__info">
                <h3 className="equipo__experiencia">15 Años de Experiencia</h3>
                <h3 className="equipo__especializacion">
                  Especialización en Gestión y Estrategia empresarial
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Ericka Castellanos Moreno</h2>
              <h3 className="equipo__cargo">Socia y Encargada del Sistema de Gestión Integrado (SGI)</h3>
            </div>
          </div>
        </div>
        {/* <div className="equipo__grid"> */}
        <div className="equipo__flex">

          <div className="equipo__persona">
            <div className="equipo5__img">
            {/* <div className="equipo__img"> */}
              <div className="equipo__info">
                <h3 className="equipo__experiencia">8 Años de experiencia</h3>
                <h3 className="equipo__especializacion">
                Especialista en Hidráulica y Neumática.
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Mateo Molina Caicedo</h2>
              <h3 className="equipo__cargo">Jefe de Taller</h3>
            </div>
          </div>

          <div className="equipo__persona">
            <div className="equipo11__img">
            {/* <div className="equipo__img"> */}
              <div className="equipo__info">
                <h3 className="equipo__experiencia">7 años de experiencia</h3>
                <h3 className="equipo__especializacion">
                Gestión administrativa. (Ing. Comercial)
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Karen Pérez Pizarro</h2>
              <h3 className="equipo__cargo">Encargada Administrativa</h3>
            </div>
          </div>
        </div>

        <div className="equipo__flex">

          <div className="equipo__persona">
            <div className="equipo3__img">
            {/* <div className="equipo__img"> */}
              <div className="equipo__info">
                <h3 className="equipo__experiencia">Técnico</h3>
                <h3 className="equipo__especializacion">
                {/* Ingeniería Mecánica en Mantenimiento Industrial. */}
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">J. Sebastian Arias</h2>
              <h3 className="equipo__cargo">Técnico</h3>
            </div>
          </div>

          <div className="equipo__persona">
            <div className="equipo4__img">
            {/* <div className="equipo__img"> */}
              <div className="equipo__info">
                <h3 className="equipo__experiencia">Encargado Marketing Digital</h3>
                <h3 className="equipo__especializacion">
                {/* Ingeniería Mecánica en Mantenimiento Industrial. */}
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Mauricio Guerrero</h2>
              <h3 className="equipo__cargo">Encargado Marketing Digital</h3>
            </div>
          </div>
        </div>

        <div className="equipo__flex">

          <div className="equipo__persona">
            <div className="equipo12__img">
            {/* <div className="equipo__img"> */}
              <div className="equipo__info">
                <h3 className="equipo__experiencia">Asistente Administrativa(Practicante)</h3>
                <h3 className="equipo__especializacion">
                {/* Ingeniería Mecánica en Mantenimiento Industrial. */}
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Yuliza Rojas</h2>
              <h3 className="equipo__cargo">Asistente Administrativa (Practicante)</h3>
            </div>
          </div>

          <div className="equipo__persona">
            <div className="equipo13__img">
            {/* <div className="equipo__img"> */}
              <div className="equipo__info">
                <h3 className="equipo__experiencia">Ayudante de Taller (Practicante)</h3>
                <h3 className="equipo__especializacion">
                {/* Ingeniería Mecánica en Mantenimiento Industrial. */}
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Víctor Quispe</h2>
              <h3 className="equipo__cargo">Ayudante de Taller (Practicante)</h3>
            </div>
          </div>
        </div>


        <div className="equipo__flex">
          <div className="equipo__persona">
            <div className="equipo10__img">
              <div className="equipo__info">
                <h3 className="equipo__experiencia">25 Años de Experiencia</h3>
                <h3 className="equipo__especializacion">
                  Diplomado en: tributación, planificación tributaria,
                  contabilidad internacional IFRS
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Pamela Araya Vilca</h2>
              <h3 className="equipo__cargo">Contador Auditor</h3>
            </div>
          </div>

          <div className="equipo__persona">
            <div className="equipo7__img">
              <div className="equipo__info">
                <h3 className="equipo__experiencia">3 Años de Experiencia</h3>
                <h3 className="equipo__especializacion">
                  Especialización en Desarrollo Web, Metodología Ágiles y Base
                  de Datos
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Franz Cortez Olmedo</h2>
              <h3 className="equipo__cargo">Desarrollador Full-Stack</h3>
            </div>
          </div>
        </div>

        <div className="equipo__flex">
          <div className="equipo__persona">
            <div className="equipo6__img">
              <div className="equipo__info">
                <h3 className="equipo__experiencia">3 Años de Experiencia</h3>
                <h3 className="equipo__especializacion">
                  Especialización en RRSS y marketing digital
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Joyce García Castellanos</h2>
              <h3 className="equipo__cargo">Encargada Redes sociales</h3>
            </div>
          </div>

          <div className="equipo__persona">
            <div className="equipo8__img">
              <div className="equipo__info">
                <h3 className="equipo__experiencia">2 Años de Experiencia</h3>
                <h3 className="equipo__especializacion">
                  Especialización en Diseño y edición digital
                </h3>
              </div>
            </div>

            <div className="equipo__text">
              <h2 className="equipo__nombre">Iskander García Castellanos</h2>
              <h3 className="equipo__cargo">Encargado Redes Sociales</h3>
            </div>
          </div>
        </div>

        <div className="equipo__persona"></div>
      </section>
      <footer className="footer">
        <div className="footer__grid" id="footer">
          <div className="footer__contacto">
            <h3 className="footer__titulo">Contáctanos</h3>
            <a href="https://wa.me/+56968659818" className="footer__a">
              <BsWhatsapp size={15} color={"#e1e1e1"} /> &nbsp;+56 9 6865 9818
            </a>
            <a href="tel:+56968659818" className="footer__a">
              <BsTelephoneInbound size={15} color={"#e1e1e1"} />
              &nbsp; +56 9 6865 9818
            </a>
            <a
              href="mailto:administracion@impactodelnorte.cl"
              className="footer__a"
            >
              <HiMail size={15} color={"#e1e1e1"} />{" "}
              &nbsp;administracion@impactodelnorte.cl
            </a>
          </div>

          <div className="footer__horario">
            <h3 className="footer__titulo">Nuestro Horario</h3>
            <p>
              Lunes a Jueves: <strong>9:00 a 19:00</strong>
            </p>
            <p>
              Viernes: <strong>9:00 a 18:00</strong>
            </p>
            <p>
              Sábados, domingos y festivos: <strong>CERRADO</strong>
            </p>
          </div>

          <div className="footer__ubicacion">
            <h3 className="footer__titulo">Encuéntranos</h3>
            <a
              href="https://maps.app.goo.gl/R1RngNobXN4ow4P8A"
              target="_blank"
              className="footer__a"
              rel="noreferrer"
            >
              <SiGooglemaps size={15} color={"#e1e1e1"} />
              &nbsp; Colombia # 650, Antofagasta
            </a>
            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1537.2943644117688!2d-70.39523170701854!3d-23.592753740747565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96ae2b2f8e4f1c6d%3A0xf8368dc7b3de01e2!2sImpacto%20del%20norte!5e0!3m2!1ses!2scl!4v1692575903581!5m2!1ses!2scl" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"/> */}
          </div>
        </div>

        <p className="footer_r">
          Todos los derechos reservados Impacto del Norte Copyright ©
        </p>
      </footer>
    </div>
  );
}

export default Nosotros;
